// ContactMail.js
import React from "react";
import { MdEmail } from "react-icons/md";

// メールリンク作成（宛先・件名・本文）
const createMailUrl = (subject, body) =>
  `mailto:contact@camarago.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

const subject = "カメラ情報をcamaragoに掲載希望";
const body = `以下の内容をご記入の上、お問い合わせください。
会社名: 
お名前：
部署名:
役職:
電話番号：
掲載希望商品数:
その他: 

`;
const ContactMailForBusinness = () => {
  return (
    <div className="bg-gray-300 rounded-xs w-11/12 md:w-1/2 m-auto my-12 pb-10">
      <div className="py-5 pl-3 w-11/12">
        <h2 className="text-xl font-bold">メールでのお問い合わせはこちら</h2>
        <p className="text-black pt-2 leading-loose">
          社内での共有が必要な場合はメールからのお問い合わせがおすすめです。
        </p>
        <small className="block pt-4">
          スマートフォン以外から閲覧されている場合、LINEでのお問合せが機能しない場合がございますので、メールでのお問い合わせを推奨いたします。
        </small>
      </div>

      <div className="space-y-10 w-11/12 md:w-4/5 m-auto py-10">
        <a
          href={createMailUrl(subject, body)}
          className="flex items-center justify-center gap-2 bg-blue-600 text-white py-3 px-5 rounded-md shadow-md hover:opacity-90 transition"
        >
          <MdEmail className="text-xl" />
          メールで問い合わせる
        </a>
      </div>
    </div>
  );
};

export default ContactMailForBusinness;
